import React from "react";

export default function ArrowButton({
  direction = "right", 
  as: As = "button",
  className = "",
  onClick,
  ...props
}) {
  const origin =
    direction === "right" ? "origin-left" : "origin-right";

  return (
    <As
      className={[
        "group relative inline-flex items-center justify-center",
        "w-14 h-14 rounded-full border border-red-600",
        "overflow-hidden",
        "transition-transform duration-300 hover:-translate-y-0.5 active:translate-y-0",
        "bg-red-600",
        className,
      ].join(" ")}
      onClick={onClick}
      {...props}
    >
      <span
        className={[
          "absolute inset-0 -z-10 rounded-full bg-white",
          origin,
          "scale-x-0 transition-transform duration-300 ease-out",
          "group-hover:scale-x-100", // covers red with white → looks transparent
        ].join(" ")}
      />

      {direction === 'right' ? <svg
        className="relative h-6 w-6 text-white transition-colors duration-300 group-hover:text-red-600"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M3 12h18" />
        <path d="M16 6l6 6-6 6" />
      </svg> : <svg
        className="relative h-6 w-6 text-white transition-colors duration-300 group-hover:text-red-600"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M21 12H3" />
        <path d="M8 6l-6 6 6 6" />
      </svg>}
    </As>
  );
}
